export const DataLayerPush = data => {
    if (typeof window !== undefined && typeof window !== 'undefined') {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(data);
        if (window?.location?.href?.includes('localhost')) {
            console.log('DataLayer Push:', data);
        }
    }
};
